module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositThirteenMonthsCustomErrorNotAllowedTitle',
        errorBody: 'contractsView-openyoungDataStep2TabForWhom',
        contentBuilder: 'depositThirteenMonthsRenovacionExcepciones_customErrorNotAllowed',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}
